import React from 'react';
import Footer from "../components/footer";
import { NavbarComponent } from '../components/navbar';
import '../styles/request.module.css';
import StepComponent from '../components/stepComponent';
import step1 from '../assets/howtopost/step1.png';
import step2 from '../assets/howtopost/step2.png';
import step3 from '../assets/howtopost/step3.png';
import step4 from '../assets/howtopost/step4.png';

export const HowToPost = () => {
    const steps = [
        {
            title: "Step 1",
            description: "First, take a pic and work your editing magic.\n\nNext, open CANNA42 and touch any of the “venues”, “products”, or “brands” buttons from the bottom menu.",
            imageUrl: step1,  // Ensure you have these images in your public folder
        },
        {
            title: "Step 2",
            description: "Select from any of the cards and touch anywhere on the card to open the page.",
            imageUrl: step2,
        },
        {
            title: "Step 3",
            description: `In the upper right corner is the "+" symbol\n\nNext, select "Add Image". That will open up to the next screen.`,
            imageUrl: step3,
        },
        {
            title: "Step 4",
            description: "Add your image and enter your caption.\n\nEarn your seeds!",
            imageUrl: step4,
        },
    ];

    return (
        <div className="page-margin" style={{ backgroundColor: '#1a1a1a' }}>
            <NavbarComponent />
            <section >
                <h1 className="text-white" style={{
                    textAlign: 'center',
                    fontFamily: 'carto-heavy',
                    marginTop: 50,
                    marginBottom: -20
                }}>How to post images</h1>
                <div className="container">
                    {steps.map((step, index) => (
                        <StepComponent
                            key={index}
                            title={step.title}
                            description={step.description}
                            imageUrl={step.imageUrl}
                        />
                    ))}
                </div>
            </section>
            <Footer />
        </div>
    );
};